import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sysTitle: '',
    opcity: 0,
    logoImg: require('@/assets/img/login/logo.png'),
    greet: '',
    logoCodeTime: [],
    logoCode: false,
    testCodeTime: [],
    testCode: false,
  },
  mutations: {
    setSysTitle(state, sys) {
      state.sysTitle = sys
    },
    setOpcity(state, args) {
      state.opcity = args;
    },
    setLogo(state, logo) {
      state.logoImg = logo;
    },
    setGreet(state, args) {
      state.greet = args;
    },
    setCode(state, {logo, isLogo, test, isTest}) {
      state.logoCodeTime = logo;
      state.logoCode = isLogo
      state.testCodeTime = test;
      state.testCode = isTest
    }
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedState({
      reducer: data => {
        return {
          logoImg: data.logoImg,
          sysTitle: data.sysTitle,
          logoCodeTime: data.logoCodeTime,
          logoCode: data.logoCode,
          testCodeTime: data.testCodeTime,
          testCode: data.testCode,
        }
      },
      storage: window.sessionStorage
    })
  ]
});
